import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export default function InfoIcon(props: Props) {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2915 8.45842H15.7082V10.8751H13.2915V8.45842ZM13.2915 13.2917H15.7082V20.5417H13.2915V13.2917ZM14.4998 2.41675C7.82984 2.41675 2.4165 7.83008 2.4165 14.5001C2.4165 21.1701 7.82984 26.5834 14.4998 26.5834C21.1698 26.5834 26.5832 21.1701 26.5832 14.5001C26.5832 7.83008 21.1698 2.41675 14.4998 2.41675ZM14.4998 24.1667C9.17109 24.1667 4.83317 19.8288 4.83317 14.5001C4.83317 9.17133 9.17109 4.83341 14.4998 4.83341C19.8286 4.83341 24.1665 9.17133 24.1665 14.5001C24.1665 19.8288 19.8286 24.1667 14.4998 24.1667Z"
        fill="currentColor"
      />
    </svg>
  );
}
